import React, { useCallback, useEffect, useState } from 'react';
import '../labels/PrintBoxLabel.css';

const SUCCESS_FLASH_MS = 1000;

export interface SuccessFlashState {
  readonly visible: boolean;
  readonly flash: () => void;
}

/** One-second green full-screen confirmation, same look as the bundle work **✓ Success!** flash. */
export function useSuccessFlash(): SuccessFlashState {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!visible) return undefined;
    const timer = window.setTimeout(() => setVisible(false), SUCCESS_FLASH_MS);
    return () => window.clearTimeout(timer);
  }, [visible]);

  const flash = useCallback((): void => setVisible(true), []);

  return { visible, flash };
}

interface SuccessFlashProps {
  readonly visible: boolean;
}

function SuccessFlash({ visible }: SuccessFlashProps): React.ReactElement | null {
  if (!visible) return null;
  return (
    <div className="success-flash" role="status">
      <div className="success-message">✓ Success!</div>
    </div>
  );
}

export default SuccessFlash;
